export function resolveInquiryEventLocation(
  eventLocation: string | undefined,
  legacyInquiryLocation: string | undefined,
): string | undefined {
  return eventLocation?.trim() || legacyInquiryLocation?.trim() || undefined
}
